import React from "react";

import { messages } from "./Team.messages";
import * as appConfig from "appConfig";

import styles from "./Team.module.scss";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

interface TEamProps {}

type TeamMember = {
  id: string;
  name: string;
  picture: string;
  position: string;
  bio: string | null;
  footer: string | null;
};

export const Team: React.FC<TEamProps> = () => {
  const { formatMessage } = useIntl();
  const [person, setPerson] = React.useState<TeamMember | null>(null);
  const ui = useUi();
  const team: TeamMember[] = [
    {
      footer: null,
      id: "team.person.jens-ahrens",
      name: "Jens Ahrens",
      picture: "jens-ahrens.png",
      position: formatMessage(messages.teamPersonJensAhrensPosition),
      bio: formatMessage(messages.teamPersonJensAhrensBio),
    },
    {
      footer: null,
      id: "team.person.markus-auer",
      name: "Markus Auer",
      picture: "markus-auer.png",
      position: formatMessage(messages.teamPersonMarkusAuerPosition),
      bio: formatMessage(messages.teamPersonMarkusAuerBio),
    },
    {
      footer: null,
      id: "team.person.marzena-czajkowska",
      name: "Marzena Czajkowska",
      picture: "marzena-czajkowska.png",
      position: formatMessage(messages.teamPersonMarzenCzajkowskaPosition),
      bio: formatMessage(messages.teamPersonMarzenCzajkowskaBio),
    },
    {
      footer: null,
      id: "team.person.daniel-deboy",
      name: "Daniel Deboy",
      picture: "daniel-deboy.png",
      position: formatMessage(messages.teamPersonDanielDeboyPosition),
      bio: formatMessage(messages.teamPersonDanielDeboyBio),
    },
    {
      footer: null,
      id: "team.person.mateusz-glowacki",
      name: "Mateusz Głowacki",
      picture: "mateusz-glowacki.png",
      position: formatMessage(messages.teamPersonMateuszGlowackiPosition),
      bio: formatMessage(messages.teamPersonMateuszGlowackiBio),
    },
    {
      footer: null,
      id: "team.person.karolina-jaruszewska",
      name: "Karolina Jaruszewska",
      picture: "karolina-jaruszewska.png",
      position: formatMessage(messages.teamPersonKarolinaJaruszewskaPosition),
      bio: formatMessage(messages.teamPersonKarolinaJaruszewskaBio),
    },
    {
      footer: null,
      id: "team.person.szymon-kucharski",
      name: "Szymon Kucharski",
      picture: "szymon-kucharski.png",
      position: formatMessage(messages.teamPersonSzymonKucharskiPosition),
      bio: formatMessage(messages.teamPersonSzymonKucharskiBio),
    },
    {
      footer: null,
      id: "team.person.marcin-luczak",
      name: "Marcin Łuczak",
      picture: "marcin-luczak.png",
      position: formatMessage(messages.teamPersonMarcinLuczakPosition),
      bio: formatMessage(messages.teamPersonMarcinLuczakBio),
    },
    {
      footer: null,
      id: "team.person.ana-monte",
      name: "Ana Monte",
      picture: "ana-monte.png",
      position: formatMessage(messages.teamPersonAnaMontePosition),
      bio: formatMessage(messages.teamPersonAnaMonteBio),
    },
    {
      footer: null,
      id: "team.person.artur-walaszczyk",
      name: "Artur Walaszczyk",
      picture: "artur-walaszczyk.png",
      position: formatMessage(messages.teamPersonArturWalaszczykPosition),
      bio: formatMessage(messages.teamPersonArturWalaszczykBio),
    },
  ];

  const partners: TeamMember[] = [
    {
      footer: null,
      id: "team.person.kevin-bolen",
      name: "Kevin Bolen",
      picture: "kevin-bolen.png",
      position: formatMessage(messages.teamPersonKevinBolenPosition),
      bio: formatMessage(messages.teamPersonKevinBolenBio),
    },
    {
      footer: null,
      id: "team.person.justyna-klamut",
      name: "Justyna Klamut",
      picture: "justyna-klamut.png",
      position: formatMessage(messages.teamPersonJustynaKlamutPosition),
      bio: formatMessage(messages.teamPersonJustynaKlamutBio),
    },
    {
      footer: null,
      id: "team.person.hyunkook-lee",
      name: "Hyunkook Lee",
      picture: "hyunkook-lee.png",
      position: formatMessage(messages.teamPersonHyunkookLeePosition),
      bio: formatMessage(messages.teamPersonHyunkookLeeBio),
    },
    {
      footer: null,
      id: "team.person.pawel-malecki",
      name: "Paweł Małecki",
      picture: "pawel-malecki.png",
      position: formatMessage(messages.teamPersonPawelMaleckiPosition),
      bio: formatMessage(messages.teamPersonPawelMaleckiBio),
    },
    {
      footer: null,
      id: "team.person.niels-pontoppidan",
      name: "Niels Pontoppidan",
      picture: "niels-pontoppidan.png",
      position: formatMessage(messages.teamPersonNielsPontoppidanPosition),
      bio: formatMessage(messages.teamPersonNielsPontoppidanBio),
    },

    {
      footer: null,
      id: "team.person.brian-schmidt",
      name: "Brian Schmidt",
      picture: "brian-schmidt.png",
      position: formatMessage(messages.teamPersonBrianSchmidtPosition),
      bio: formatMessage(messages.teamPersonBrianSchmidtBio),
    },
  ];

  function renderList(): React.ReactNode {
    return (
      <div>
        <div className={styles.titleWrapper}>
          <h1>{formatMessage(messages.title)}</h1>
        </div>
        <div className={styles.listWrapper}>
          {team.map((member) => {
            return (
              <div className={styles.cell} key={member.id} onClick={() => setPerson(member)}>
                <div className={styles.avatarWrapper}>
                  <div className={styles.avatarInnerWrapper}>
                    <img
                      className={styles.avatar}
                      src={`${appConfig.STATIC_ASSETS_URL}/team/${member.picture}`}
                      alt={member.name}
                    />
                    <span className={styles.avatarArrow}>
                      <i className="cil-arrow-right" />
                    </span>
                  </div>
                </div>
                <div className={styles.personInfoWrapper}>
                  <b className={styles.personName}>{member.name}</b>
                  <div className={styles.personPosition}>{member.position}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.titleWrapper}>
          <h1>{formatMessage(messages.titlePartners)}</h1>
        </div>
        <div className={styles.listWrapper}>
          {partners.map((member) => {
            return (
              <div className={styles.cell} key={member.id} onClick={() => setPerson(member)}>
                <div className={styles.avatarWrapper}>
                  <div className={styles.avatarInnerWrapper}>
                    <img
                      className={styles.avatar}
                      src={`${appConfig.STATIC_ASSETS_URL}/team/${member.picture}`}
                      alt={member.name}
                    />
                    <span className={styles.avatarArrow}>
                      <i className="cil-arrow-right" />
                    </span>
                  </div>
                </div>
                <div className={styles.personInfoWrapper}>
                  <b className={styles.personName}>{member.name}</b>
                  <div className={styles.personPosition}>{member.position}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  function renderPerson(currentPerson: TeamMember): React.ReactNode {
    return (
      <div className={styles.singlePersonWrapper}>
        <div className={styles.avatarWrapper}>
          <div className={styles.avatarInnerWrapper}>
            <img
              className={styles.avatar}
              src={`${appConfig.STATIC_ASSETS_URL}/team/${currentPerson.picture}`}
              alt={currentPerson.name}
            />
          </div>
        </div>
        <div className={styles.personInfoWrapper}>
          <b className={styles.personName}>{currentPerson.name}</b>
          <div className={styles.personPosition}>{currentPerson.position}</div>
          <div dangerouslySetInnerHTML={{ __html: currentPerson.bio ?? "" }} className={styles.personBio}></div>
        </div>

        <ui.Button
          icon="cil-arrow-left"
          shape={"round"}
          theme={"primary"}
          size={"standard"}
          onClick={() => setPerson(null)}
        />
      </div>
    );
  }

  return <div className={styles.root}>{person == null ? renderList() : renderPerson(person)}</div>;
};
